import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97d4c102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropbox" }
const _hoisted_2 = ["id", "accept"]
const _hoisted_3 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: 'fileinput-' + _ctx.state.id,
      type: "file",
      class: "input-file",
      accept: _ctx.accept,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filesChange($event.target.files)))
    }, null, 40, _hoisted_2),
    (!_ctx.state.file)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(" Dra din bild hit eller"),
          _hoisted_4,
          _createTextVNode(" klicka för att välja.. ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.file)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.loadingThumbnail)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                id: 'preview-' + _ctx.state.id,
                src: "",
                width: "200",
                class: "img-thumbnail"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.state.fileName), 1)
  ]))
}